import axiosInstance from './axiosInstance'

export const getConfigByName = (name) => {
  return axiosInstance.get(`/configs/${name}`)
}

export const createConfig = (data) => {
  return axiosInstance.post('/configs', data)
}

export const updateConfigByName = (name, data) => {
  return axiosInstance.put(`/configs/${name}`, data)
}

export const deleteConfigByName = (name) => {
  return axiosInstance.delete(`/configs/${name}`)
}

export const getConfigEmcPricing = () => {
  return axiosInstance.get('/configs/emc-pricing')
}
